import React from 'react';
import { Quote } from 'lucide-react';
const lesgevers = [{
  name: 'An Verhoeven',
  specialty: 'Keramiek',
  bio: 'An is keramiste en geeft al meer dan tien jaar workshops bij De Maekerij. Ze leert je de basis van draaien, boetseren en glazuren — altijd met veel geduld en een vleugje humor. Haar atelier staat vol met kleurrijke experimenten en mislukte meesterwerken waar ze even trots op is.',
  quote: 'Klei heeft geen haast. Het leert je om te vertragen en écht met je handen bezig te zijn.'
}, {
  name: 'Thomas Janssens',
  specialty: 'Drukwerk & Letterpress',
  bio: 'Thomas is grafisch ontwerper en letterpresser. Hij combineert traditionele druktechnieken met een eigentijdse blik. In zijn workshops leer je werken met loodletters, linosnede en zeefdruk. Thomas gelooft dat het tastbare van drukwerk in een digitale wereld alleen maar waardevoller wordt.',
  quote: 'Er is iets magisch aan dat moment waarop je de pers naar beneden duwt en je ontwerp voor het eerst op papier verschijnt.'
}, {
  name: 'Nathalie Peeters',
  specialty: 'Naaldvilten & Textiel',
  bio: 'Nathalie ontdekte naaldvilten tijdens een reis door Scandinavië en was meteen verkocht. Ondertussen geeft ze workshops in 2D en 3D naaldvilten, macramé en weven. Ze staat bekend om haar aanstekelijk enthousiasme en haar talent om beginners op hun gemak te stellen.',
  quote: 'Met een naald en wat wol kun je de mooiste dingen maken. Het is meditatief én creatief tegelijk.'
}, {
  name: 'Selia Hendrickx',
  specialty: 'Fermenteren & Koken',
  bio: 'Selia is de oprichtster van Selia&Scob en een fermentatie-expert. Van kombucha tot kimchi, van zuurdesem tot kefir — Selia deelt haar kennis met passie en humor. Haar workshops zijn altijd een mix van wetenschap, koken en gezellig samen proeven.',
  quote: 'Fermenteren is geduld hebben en vertrouwen dat de natuur haar werk doet. Het resultaat is altijd verrassend.'
}, {
  name: 'Pieter De Smedt',
  specialty: 'Tuinontwerp',
  bio: 'Pieter is landschapsarchitect en helpt je om je droomtuin op papier te zetten. In zijn workshops leer je de basisprincipes van tuinontwerp: van bodemanalyse tot plantenkeuze, van tekenen tot realisatie. Pieter gelooft dat een goed tuinplan begint bij goed luisteren naar de plek.',
  quote: 'Een tuin is nooit af — en dat is precies wat het zo mooi maakt.'
}, {
  name: 'Lotte Van Damme',
  specialty: 'Juwelen',
  bio: 'Lotte is zilversmid en juweelontwerpster. Ze leert je werken met metaal, stenen en draad om unieke sieraden te maken. Of het nu gaat om een eenvoudige ring of een complexe hanger, Lotte begeleidt je stap voor stap met oog voor detail en vakmanschap.',
  quote: 'Een juweel dat je zelf maakt, draagt altijd een verhaal met zich mee.'
}, {
  name: 'Ines Claes',
  specialty: 'Parfum & Verzorging',
  bio: 'Ines is aromatherapeut en maakt al jaren haar eigen natuurlijke cosmetica. In haar workshops leer je parfum, zeep of lippenbalsem maken met pure ingrediënten. Ines neemt je mee in de wereld van geuren en texturen, altijd met aandacht voor duurzaamheid.',
  quote: 'Je eigen parfum maken is als een geur-dagboek schrijven. Elke noot vertelt iets over wie je bent.'
}, {
  name: 'Wouter Michiels',
  specialty: 'Pen(seel) en Papier',
  bio: 'Wouter is illustrator en aquarellist. Hij geeft workshops rond tekenen, aquarel en mixed media. Zijn aanpak is laagdrempelig: iedereen kan tekenen, vindt Wouter, je moet alleen durven beginnen. Zijn workshops zijn een mix van techniek, experiment en veel lachen.',
  quote: 'Tekenen is niet kopiëren wat je ziet, maar laten zien hoe jij de wereld ervaart.'
}];
export function Lesgevers() {
  return <div className="container mx-auto px-4 py-12" data-id="element-697">
      <div className="max-w-4xl mx-auto" data-id="element-698">
        {/* Page header */}
        <div className="mb-8" data-id="element-699">
          <h1 className="text-3xl md:text-4xl font-bold uppercase tracking-wide" data-id="element-700">
            Lesgevers
          </h1>
        </div>

        <p className="text-lg text-gray-600 leading-relaxed mb-16 max-w-3xl" data-id="element-701">
          Onze workshops worden gegeven door gepassioneerde vakexperts. Ze delen
          graag hun kennis, begeleiden je met geduld en zorgen ervoor dat je met
          een goed gevoel én een mooi resultaat naar huis gaat. Maak kennis met
          ons team van lesgevers.
        </p>

        {/* Lesgevers list */}
        <div className="space-y-20" data-id="element-702">
          <div className="flex flex-col md:flex-row-reverse gap-8 items-start" data-id="element-703">
            {/* Photo */}
            <div className="md:w-1/3 flex-shrink-0" data-id="element-704">
              <div className="border-2 border-dashed border-gray-300 w-48 h-48 md:w-full md:h-64 rounded-lg flex items-center justify-center bg-gray-100" data-id="element-705">
                <span className="text-gray-400 text-sm" data-id="element-706">Foto An Verhoeven</span>
              </div>
            </div>
            {/* Content */}
            <div className="md:w-2/3" data-id="element-707">
              <h2 className="text-xl font-bold mb-1" data-id="element-708">An Verhoeven</h2>
              <p className="text-sm text-gray-500 italic mb-4" data-id="element-709">Keramiek</p>
              <p className="text-sm text-gray-600 leading-relaxed mb-4" data-id="element-710">
                An is keramiste en geeft al meer dan tien jaar workshops bij De
                Maekerij. Ze leert je de basis van draaien, boetseren en
                glazuren — altijd met veel geduld en een vleugje humor. Haar
                atelier staat vol met kleurrijke experimenten en mislukte
                meesterwerken waar ze even trots op is.
              </p>
              <div className="border-l-2 border-gray-300 pl-4 mt-4" data-id="element-711">
                <Quote size={16} className="text-gray-400 mb-1" data-id="element-712" />
                <p className="text-sm text-gray-700 italic" data-id="element-713">
                  "Klei heeft geen haast. Het leert je om te vertragen en écht
                  met je handen bezig te zijn."
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-714">
            <div className="md:w-1/3 flex-shrink-0" data-id="element-715">
              <div className="border-2 border-dashed border-gray-300 w-48 h-48 md:w-full md:h-64 rounded-lg flex items-center justify-center bg-gray-100" data-id="element-716">
                <span className="text-gray-400 text-sm" data-id="element-717">
                  Foto Thomas Janssens
                </span>
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-718">
              <h2 className="text-xl font-bold mb-1" data-id="element-719">Thomas Janssens</h2>
              <p className="text-sm text-gray-500 italic mb-4" data-id="element-720">
                Drukwerk & Letterpress
              </p>
              <p className="text-sm text-gray-600 leading-relaxed mb-4" data-id="element-721">
                Thomas is grafisch ontwerper en letterpresser. Hij combineert
                traditionele druktechnieken met een eigentijdse blik. In zijn
                workshops leer je werken met loodletters, linosnede en zeefdruk.
                Thomas gelooft dat het tastbare van drukwerk in een digitale
                wereld alleen maar waardevoller wordt.
              </p>
              <div className="border-l-2 border-gray-300 pl-4 mt-4" data-id="element-722">
                <Quote size={16} className="text-gray-400 mb-1" data-id="element-723" />
                <p className="text-sm text-gray-700 italic" data-id="element-724">
                  "Er is iets magisch aan dat moment waarop je de pers naar
                  beneden duwt en je ontwerp voor het eerst op papier
                  verschijnt."
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row-reverse gap-8 items-start" data-id="element-725">
            <div className="md:w-1/3 flex-shrink-0" data-id="element-726">
              <div className="border-2 border-dashed border-gray-300 w-48 h-48 md:w-full md:h-64 rounded-lg flex items-center justify-center bg-gray-100" data-id="element-727">
                <span className="text-gray-400 text-sm" data-id="element-728">
                  Foto Nathalie Peeters
                </span>
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-729">
              <h2 className="text-xl font-bold mb-1" data-id="element-730">Nathalie Peeters</h2>
              <p className="text-sm text-gray-500 italic mb-4" data-id="element-731">
                Naaldvilten & Textiel
              </p>
              <p className="text-sm text-gray-600 leading-relaxed mb-4" data-id="element-732">
                Nathalie ontdekte naaldvilten tijdens een reis door Scandinavië
                en was meteen verkocht. Ondertussen geeft ze workshops in 2D en
                3D naaldvilten, macramé en weven. Ze staat bekend om haar
                aanstekelijk enthousiasme en haar talent om beginners op hun
                gemak te stellen.
              </p>
              <div className="border-l-2 border-gray-300 pl-4 mt-4" data-id="element-733">
                <Quote size={16} className="text-gray-400 mb-1" data-id="element-734" />
                <p className="text-sm text-gray-700 italic" data-id="element-735">
                  "Met een naald en wat wol kun je de mooiste dingen maken. Het
                  is meditatief én creatief tegelijk."
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-736">
            <div className="md:w-1/3 flex-shrink-0" data-id="element-737">
              <div className="border-2 border-dashed border-gray-300 w-48 h-48 md:w-full md:h-64 rounded-lg flex items-center justify-center bg-gray-100" data-id="element-738">
                <span className="text-gray-400 text-sm" data-id="element-739">
                  Foto Selia Hendrickx
                </span>
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-740">
              <h2 className="text-xl font-bold mb-1" data-id="element-741">Selia Hendrickx</h2>
              <p className="text-sm text-gray-500 italic mb-4" data-id="element-742">
                Fermenteren & Koken
              </p>
              <p className="text-sm text-gray-600 leading-relaxed mb-4" data-id="element-743">
                Selia is de oprichtster van Selia&Scob en een
                fermentatie-expert. Van kombucha tot kimchi, van zuurdesem tot
                kefir — Selia deelt haar kennis met passie en humor. Haar
                workshops zijn altijd een mix van wetenschap, koken en gezellig
                samen proeven.
              </p>
              <div className="border-l-2 border-gray-300 pl-4 mt-4" data-id="element-744">
                <Quote size={16} className="text-gray-400 mb-1" data-id="element-745" />
                <p className="text-sm text-gray-700 italic" data-id="element-746">
                  "Fermenteren is geduld hebben en vertrouwen dat de natuur haar
                  werk doet. Het resultaat is altijd verrassend."
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row-reverse gap-8 items-start" data-id="element-747">
            <div className="md:w-1/3 flex-shrink-0" data-id="element-748">
              <div className="border-2 border-dashed border-gray-300 w-48 h-48 md:w-full md:h-64 rounded-lg flex items-center justify-center bg-gray-100" data-id="element-749">
                <span className="text-gray-400 text-sm" data-id="element-750">
                  Foto Pieter De Smedt
                </span>
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-751">
              <h2 className="text-xl font-bold mb-1" data-id="element-752">Pieter De Smedt</h2>
              <p className="text-sm text-gray-500 italic mb-4" data-id="element-753">Tuinontwerp</p>
              <p className="text-sm text-gray-600 leading-relaxed mb-4" data-id="element-754">
                Pieter is landschapsarchitect en helpt je om je droomtuin op
                papier te zetten. In zijn workshops leer je de basisprincipes
                van tuinontwerp: van bodemanalyse tot plantenkeuze, van tekenen
                tot realisatie. Pieter gelooft dat een goed tuinplan begint bij
                goed luisteren naar de plek.
              </p>
              <div className="border-l-2 border-gray-300 pl-4 mt-4" data-id="element-755">
                <Quote size={16} className="text-gray-400 mb-1" data-id="element-756" />
                <p className="text-sm text-gray-700 italic" data-id="element-757">
                  "Een tuin is nooit af — en dat is precies wat het zo mooi
                  maakt."
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-758">
            <div className="md:w-1/3 flex-shrink-0" data-id="element-759">
              <div className="border-2 border-dashed border-gray-300 w-48 h-48 md:w-full md:h-64 rounded-lg flex items-center justify-center bg-gray-100" data-id="element-760">
                <span className="text-gray-400 text-sm" data-id="element-761">
                  Foto Lotte Van Damme
                </span>
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-762">
              <h2 className="text-xl font-bold mb-1" data-id="element-763">Lotte Van Damme</h2>
              <p className="text-sm text-gray-500 italic mb-4" data-id="element-764">Juwelen</p>
              <p className="text-sm text-gray-600 leading-relaxed mb-4" data-id="element-765">
                Lotte is zilversmid en juweelontwerpster. Ze leert je werken met
                metaal, stenen en draad om unieke sieraden te maken. Of het nu
                gaat om een eenvoudige ring of een complexe hanger, Lotte
                begeleidt je stap voor stap met oog voor detail en vakmanschap.
              </p>
              <div className="border-l-2 border-gray-300 pl-4 mt-4" data-id="element-766">
                <Quote size={16} className="text-gray-400 mb-1" data-id="element-767" />
                <p className="text-sm text-gray-700 italic" data-id="element-768">
                  "Een juweel dat je zelf maakt, draagt altijd een verhaal met
                  zich mee."
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row-reverse gap-8 items-start" data-id="element-769">
            <div className="md:w-1/3 flex-shrink-0" data-id="element-770">
              <div className="border-2 border-dashed border-gray-300 w-48 h-48 md:w-full md:h-64 rounded-lg flex items-center justify-center bg-gray-100" data-id="element-771">
                <span className="text-gray-400 text-sm" data-id="element-772">Foto Ines Claes</span>
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-773">
              <h2 className="text-xl font-bold mb-1" data-id="element-774">Ines Claes</h2>
              <p className="text-sm text-gray-500 italic mb-4" data-id="element-775">
                Parfum & Verzorging
              </p>
              <p className="text-sm text-gray-600 leading-relaxed mb-4" data-id="element-776">
                Ines is aromatherapeut en maakt al jaren haar eigen natuurlijke
                cosmetica. In haar workshops leer je parfum, zeep of
                lippenbalsem maken met pure ingrediënten. Ines neemt je mee in
                de wereld van geuren en texturen, altijd met aandacht voor
                duurzaamheid.
              </p>
              <div className="border-l-2 border-gray-300 pl-4 mt-4" data-id="element-777">
                <Quote size={16} className="text-gray-400 mb-1" data-id="element-778" />
                <p className="text-sm text-gray-700 italic" data-id="element-779">
                  "Je eigen parfum maken is als een geur-dagboek schrijven. Elke
                  noot vertelt iets over wie je bent."
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-780">
            <div className="md:w-1/3 flex-shrink-0" data-id="element-781">
              <div className="border-2 border-dashed border-gray-300 w-48 h-48 md:w-full md:h-64 rounded-lg flex items-center justify-center bg-gray-100" data-id="element-782">
                <span className="text-gray-400 text-sm" data-id="element-783">
                  Foto Wouter Michiels
                </span>
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-784">
              <h2 className="text-xl font-bold mb-1" data-id="element-785">Wouter Michiels</h2>
              <p className="text-sm text-gray-500 italic mb-4" data-id="element-786">
                Pen(seel) en Papier
              </p>
              <p className="text-sm text-gray-600 leading-relaxed mb-4" data-id="element-787">
                Wouter is illustrator en aquarellist. Hij geeft workshops rond
                tekenen, aquarel en mixed media. Zijn aanpak is laagdrempelig:
                iedereen kan tekenen, vindt Wouter, je moet alleen durven
                beginnen. Zijn workshops zijn een mix van techniek, experiment
                en veel lachen.
              </p>
              <div className="border-l-2 border-gray-300 pl-4 mt-4" data-id="element-788">
                <Quote size={16} className="text-gray-400 mb-1" data-id="element-789" />
                <p className="text-sm text-gray-700 italic" data-id="element-790">
                  "Tekenen is niet kopiëren wat je ziet, maar laten zien hoe jij
                  de wereld ervaart."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}